import svg from './row-svg/date.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DateIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default DateIcon;
